import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessagesRoutingModule } from './messages-routing.module';
import { AlreadyProcessedComponent } from './pages/already-processed/already-processed.component';
import { ExpiredComponent } from './pages/expired/expired.component';


@NgModule({
  declarations: [
    AlreadyProcessedComponent,
    ExpiredComponent
  ],
  imports: [
    CommonModule,
    MessagesRoutingModule
  ]
})
export class MessagesModule { }
